<template>
    <div class="time-picker">
        <div class="wrap">
            <div class="title">期望上门时间<span class="icon-close" @click="close()"></span></div>
            <div class="detail">
                <div class="left">
                    <div
                        v-for="(day, index) in days"
                        :key="day.code"
                        :class="['item', { active: index === selectedDayIndex }]"
                        @click="selectDay(day, index)"
                    >
                        {{ day.name }}
                    </div>
                </div>
                <div class="right">
                    <div
                        v-for="(time, index) in days[selectedDayIndex].times"
                        :key="time.begin"
                        :class="['item', { active: index === selectedTimeIndex }]"
                        @click="selectTime(index)"
                    >
                        {{ time.desc ? time.desc : [time.begin, time.end].join('-') }}
                        <img v-if="index === selectedTimeIndex" src="@/assets/images/price/yes.png" alt="勾选图标" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { timeQuantum, days } from './config'
import moment from 'moment'

export default {
    props: {
        dayIndex: {
            // eslint-disable-next-line vue/require-prop-type-constructor
            type: Number | String,
            default: 0
        },
        timeIndex: {
            // eslint-disable-next-line vue/require-prop-type-constructor
            type: Number | String,
            default: 0
        },
        isFirst: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            days: [],
            times: [],
            selectedDayIndex: 0,
            selectedTimeIndex: 0
        }
    },
    created() {
        this.days = [...days]
        const times = [...timeQuantum]
        this.days.forEach(item => {
            if (item.code === 'day2') {
                item.date = moment(new Date()).add(1, 'days').format('YYYY-MM-DD')
                item.times = times
            } else if (item.code === 'day3') {
                item.date = moment(new Date()).add(2, 'days').format('YYYY-MM-DD')
                item.times = times
            } else {
                item.date = moment(new Date()).format('YYYY-MM-DD')
            }
        })
        let curHour = new Date().getHours()
        if (curHour > 19) {
            this.days = this.days.slice(1)
        } else if (curHour < 8) {
            this.days[0].times = times
        } else {
            curHour = curHour = [curHour < 10 ? '0' : '', curHour, ':00'].join('')
            const index = times.findIndex(item => item.begin === curHour)
            if (index > -1) {
                this.days[0].times = times.slice(index)
            }
            if (this.days[0].times && this.days[0].times.length > 0) {
                this.days[0].times[0] = Object.assign({}, { ...this.days[0].times[0], desc: '一小时内' })
            }
        }
        this.selectedDayIndex = this.dayIndex
        this.selectedTimeIndex = this.timeIndex
        this.isFirst && this.selectTime(0)
    },
    methods: {
        selectDay(item, index) {
            this.selectedDayIndex = index
            if (this.selectedDayIndex === this.dayIndex) {
                this.selectedTimeIndex = this.timeIndex
            } else {
                this.selectedTimeIndex = -1
            }
        },
        selectTime(index) {
            this.selectedTimeIndex = index
            const time = `${this.days[this.selectedDayIndex].date}T${this.days[this.selectedDayIndex].times[this.selectedTimeIndex].begin}:00+08:00`
            const timeDes = `${this.days[this.selectedDayIndex].name} ${
                this.days[this.selectedDayIndex].times[this.selectedTimeIndex].desc
                    ? this.days[this.selectedDayIndex].times[this.selectedTimeIndex].desc
                    : `${this.days[this.selectedDayIndex].times[this.selectedTimeIndex].begin}:00-${
                          this.days[this.selectedDayIndex].times[this.selectedTimeIndex].end
                      }`
            }`
            this.close({
                time,
                timeDes,
                selectedTimeIndex: this.selectedTimeIndex,
                selectedDayIndex: this.selectedDayIndex
            })
        },
        close(time = '') {
            this.$emit('on-close', time)
        }
    }
}
</script>

<style scoped lang="scss">
.time-picker {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99;
    .wrap {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background: #fff;
        border-radius: 0.08rem 0.08rem 0 0;
        .title {
            height: 1.14rem;
            line-height: 1.14rem;
            padding-left: 0.44rem;
            font-size: 0.32rem;
            color: #333333;
            .icon-close {
                position: absolute;
                top: 0.26rem;
                right: 0.5rem;
                width: 0.5rem;
                height: 0.5rem;
                &:before {
                    position: absolute;
                    top: 50%;
                    content: '';
                    display: block;
                    height: 5px;
                    width: 0.36rem;
                    background: #000;
                    transform: rotate(45deg);
                }
                &:after {
                    position: absolute;
                    top: 50%;
                    content: '';
                    display: block;
                    height: 5px;
                    width: 0.36rem;
                    background: #000;
                    transform: rotate(-45deg);
                }
            }
        }
        .detail {
            display: flex;
            .left {
                width: 2.3rem;
                background: #f3f3f3;
                padding-bottom: 0.6rem;
                .item {
                    height: 1.04rem;
                    line-height: 1.04rem;
                    font-size: 0.3rem;
                    color: #666666;
                    text-align: center;
                    &.active {
                        color: #dc1e32;
                        background: #fff;
                    }
                }
            }
            .right {
                flex-grow: 1;
                overflow: auto;
                max-height: 5rem;
                .item {
                    height: 0.86rem;
                    line-height: 0.86rem;
                    font-size: 0.28rem;
                    color: #333333;
                    letter-spacing: 0;
                    text-align: left;
                    padding-left: 0.42rem;
                    position: relative;
                    img {
                        width: 0.32rem;
                        height: 0.32rem;
                        position: absolute;
                        right: 0.25rem;
                        top: 0.2rem;
                    }
                    &.active {
                        color: #dc1e32;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/time-picker/index.vue